import { render, staticRenderFns } from "./IsProtectionMeasureDoneQuestion.vue?vue&type=template&id=6a20d8ba&scoped=true"
import script from "./IsProtectionMeasureDoneQuestion.vue?vue&type=script&lang=ts"
export * from "./IsProtectionMeasureDoneQuestion.vue?vue&type=script&lang=ts"
import style0 from "./IsProtectionMeasureDoneQuestion.vue?vue&type=style&index=0&id=6a20d8ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a20d8ba",
  null
  
)

export default component.exports